import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard/Dashboard.vue";

import PortfoliosIndex from "@/pages/Dashboard/Portfolios/PortfoliosIndex.vue";
import PortfolioWizard from "@/pages/Dashboard/Portfolios/PortfolioWizard.vue";

let portfoliosMenu = {
    path: "/portfolios",
    component: DashboardLayout,
    children: [
        {
            path: "",
            name: "Portfolios Index",
            components: { default: PortfoliosIndex }
        },
        {
            path: "new",
            name: "New Portfolio",
            components: { default: PortfolioWizard }
        },
        {
            path: ":portfolioId/buildings",
            name: "Buildings By Portfolio",
            components: { default: BuildingsIndex }
        },
        {
            path: ":portfolioId/buildings/new",
            name: "New Building - Core Details",
            components: { default: BuildingWizard }
        }
    ]
};

let editPortfoliosMenu = {
    path: "/portfolios/:portfolioId",
    component: DashboardLayout,
    name: "Edit Portfolio",
    redirect: "/portfolios/:portfolioId/details",
    children: [
        {
            path: "details",
            name: "Edit Portfolio - Core Details",
            components: { default: PortfolioWizard }
        },
        {
            path: "address",
            name: "Edit Portfolio - Address",
            components: { default: PortfolioWizard }
        },
        {
            path: "contact",
            name: "Edit Portfolio - Contact",
            components: { default: PortfolioWizard }
        },
        {
            path: "files",
            name: "Edit Portfolio - Files",
            components: { default: PortfolioWizard }
        },
        {
            path: "complete",
            name: "Edit Portfolio - Complete",
            components: { default: PortfolioWizard }
        }
    ]
};


import BuildingsIndex from "@/pages/Dashboard/Buildings/BuildingsIndex.vue";
import BuildingWizard from "@/pages/Dashboard/Buildings/BuildingWizard.vue";

let buildingsMenu = {
    path: "/buildings",
    component: DashboardLayout,
    children: [
        {
            path: "",
            name: "Buildings Index",
            components: { default: BuildingsIndex }
        }
    ]
};

let editBuildingsMenu = {
    path: "/buildings/:buildingId",
    component: DashboardLayout,
    name: "Edit Building",
    redirect: "/buildings/:buildingId/details",
    children: [
        {
            path: "details",
            name: "Edit Building - Core Details",
            components: { default: BuildingWizard },
            children: [
                {
                    path: "contacts",
                    name: "Edit Building - Contacts",
                    components: { default: BuildingWizard }
                },
                {
                    path: "address",
                    name: "Edit Building - Address",
                    components: { default: BuildingWizard }
                },
                {
                    path: "location",
                    name: "Edit Building - Location",
                    components: { default: BuildingWizard }
                },
                {
                    path: "serviceCharge",
                    name: "Edit Building - Service Charge",
                    components: { default: BuildingWizard }
                }
            ]
        },
        {
            path: "amenities",
            name: "Edit Building - Amenities",
            components: { default: BuildingWizard },
            children: [
                {
                    path: "info",
                    name: "Edit Building - Further Info",
                    components: { default: BuildingWizard }
                },
                {
                    path: "visitorProcess",
                    name: "Edit Building - Visitor Process",
                    components: { default: BuildingWizard }
                }
            ]
        },
        {
            path: "files",
            name: "Edit Building - Files",
            components: { default: BuildingWizard },
            children: [
                {
                    path: "organise",
                    name: "Edit Building - Organise Files",
                    components: { default: BuildingWizard }
                }
            ]
        },
        {
            path: "tenants",
            name: "Edit Building - Tenants",
            components: { default: BuildingWizard },
            children: [
                {
                    path: "info",
                    name: "Edit Building - Tenants Info",
                    components: { default: BuildingWizard }
                }
            ]
        },
        {
            path: "complete",
            name: "Edit Building - Complete",
            components: { default: BuildingWizard }
        }
    ]
};

import FacilitiesManagersIndex from "@/pages/Dashboard/FacilitiesManagers/FacilitiesManagersIndex.vue";
import FacilitiesManagerWizard from "@/pages/Dashboard/FacilitiesManagers/FacilitiesManagerWizard.vue";

let facilitiesManagersMenu = {
    path: "/facilities-managers",
    component: DashboardLayout,
    children: [
        {
            path: "",
            name: "Facilities Managers Index",
            components: { default: FacilitiesManagersIndex }
        },
        {
            path: "by-building/:buildingId",
            name: "Facilities Managers For Building",
            components: { default: FacilitiesManagersIndex }
        },
        {
            path: "by-portfolio/:portfolioId",
            name: "Facilities Managers For Portfolio",
            components: { default: FacilitiesManagersIndex }
        },
        {
            path: "new",
            name: "New Facilities Manager",
            components: { default: FacilitiesManagerWizard }
        }
        //,
        //{
        //    path: ":id",
        //    name: "Edit Facilities Manager",
        //    components: { default: FacilitiesManagerWizard }
        //}
    ]
};

let editFacilitiesManagersMenu = {
    path: "/facilities-managers/:facilitiesManagerId",
    component: DashboardLayout,
    name: "Edit Facilities Manager",
    redirect: "/facilities-managers/:facilitiesManagerId/details",
    children: [
        {
            path: "details",
            name: "Edit Facilities Manager - Core Details",
            components: { default: FacilitiesManagerWizard }
        },
        {
            path: "contact",
            name: "Edit Facilities Manager - Contact",
            components: { default: FacilitiesManagerWizard }
        },
        {
            path: "files",
            name: "Edit Facilities Manager - Files",
            components: { default: FacilitiesManagerWizard }
        },
        {
            path: "complete",
            name: "Edit Facilities Manager - Complete",
            components: { default: FacilitiesManagerWizard }
        }
    ]
};

import OneOffFeesIndex from "@/pages/Dashboard/OneOffFees/OneOffFeesIndex.vue";
import OneOffFeeWizard from "@/pages/Dashboard/OneOffFees/OneOffFeeWizard.vue";

let oneOffFeesMenu = {
    path: "/one-off-fees",
    component: DashboardLayout,
    children: [
        {
            path: "",
            name: "One Off Fees Index",
            components: { default: OneOffFeesIndex }
        },
        {
            path: "by-building/:buildingId",
            name: "One Off Fees For Building",
            components: { default: OneOffFeesIndex }
        },
        {
            path: "by-portfolio/:portfolioId",
            name: "One Off Fees For Portfolio",
            components: { default: OneOffFeesIndex }
        },
        {
            path: "new/:buildingId",
            name: "New One Off Fee",
            components: { default: OneOffFeeWizard }
        },
        {
            path: ":oneOffFeeId",
            name: "Edit One Off Fee",
            components: { default: OneOffFeeWizard }
        }
    ]
};

import NotificationsIndex from "@/pages/Dashboard/Notifications/NotificationsIndex.vue";
import NotificationWizard from "@/pages/Dashboard/Notifications/NotificationWizard.vue";

let notificationsMenu = {
    path: "/notifications",
    component: DashboardLayout,
    children: [
        {
            path: "",
            name: "Notifications Index",
            components: { default: NotificationsIndex }
        },
        {
            path: "by-building/:buildingId",
            name: "Notification For Building",
            components: { default: NotificationsIndex }
        },
        {
            path: "by-portfolio/:portfolioId",
            name: "Notifications For Portfolio",
            components: { default: NotificationsIndex }
        },
        {
            path: ":buildingId",
            name: "Edit Notification",
            components: { default: NotificationWizard }
        }
    ]
};

import ContactsIndex from "@/pages/Dashboard/Contacts/ContactsIndex.vue";
import ContactWizard from "@/pages/Dashboard/Contacts/ContactWizard.vue";

let contactsMenu = {
    path: "/contacts",
    component: DashboardLayout,
    children: [
        {
            path: "",
            name: "Contacts Index",
            components: { default: ContactsIndex } //TODO:TD add new path(s) for against FM, P and C ?
        },
        {
            path: "new",
            name: "New Contact",
            components: { default: ContactWizard }
        },
        {
            path: ":contactId",
            name: "Edit Contact",
            components: { default: ContactWizard }
        }
    ]
};

import Profile from "@/auth/Profile.vue";

import AmenitiesWizard from "@/pages/Dashboard/Websites/AmenitiesWizard.vue";
import VisitorProcessWizard from "@/pages/Dashboard/Websites/VisitorProcessWizard.vue";
import TenantsWizard from "@/pages/Dashboard/Websites/TenantsWizard.vue";
import PoisWizard from "@/pages/Dashboard/Websites/PoisWizard.vue";
import StreetViewWizard from "@/pages/Dashboard/Websites/StreetViewWizard.vue";
import WebsiteWizard from "@/pages/Dashboard/Websites/WebsiteWizard.vue";


let websitesMenu = {
    path: "/websites",
    component: DashboardLayout,
    children: [
        {
            path: ":buildingId/amenities",
            name: "Amenities",
            components: { default: AmenitiesWizard }
        },
        {
            path: ":buildingId/visitorProcess",
            name: "Visitor Process",
            components: { default: VisitorProcessWizard }
        },
        {
            path: ":buildingId/tenants",
            name: "Tenants",
            components: { default: TenantsWizard }
        },
        {
            path: ":buildingId/pois",
            name: "Pois & Links",
            components: { default: PoisWizard }
        },
        {
            path: ":buildingId/streetview",
            name: "Street View",
            components: { default: StreetViewWizard }
        },
        {
            path: ":buildingId/website",
            name: "Edit Website",
            components: { default: WebsiteWizard }
        }
    ]
};

import AuthFail from "@/auth/Fail.vue";

const routes = [
    {
        path: "/",
        component: DashboardLayout,
        redirect: "dashboard",
        children: [
            {
                path: "dashboard",
                name: "Dashboard",
                components: { default: Dashboard }
            },
            {
                path: "profile",
                name: "Profile",
                components: { default: Profile }
            }
        ]
    },

    {
        path: "/auth/fail",
        name: "Auth Fail",
        component: AuthFail,
    },

    portfoliosMenu,
    editPortfoliosMenu,
    buildingsMenu,
    editBuildingsMenu,
    oneOffFeesMenu,
    notificationsMenu,
    facilitiesManagersMenu,
    editFacilitiesManagersMenu,
    contactsMenu,
    websitesMenu,
];

export default routes;